import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { VideoBackground } from "@/components/ui/video-background";

export default function HeroSection() {
  return (
    <section className="relative min-h-[100svh] overflow-hidden">
      {/* === Video Background Layer === */}
      <VideoBackground
        src="/videos/hero-video1.mp4?v=20260615"
        srcMobile="/videos/hero-2.mp4?v=20260615"
        poster="/videos/hero-poster.webp"
        posterMobile="/videos/hero-poster-mobile.webp"
        overlay="dark"
        topGlow
        bottomFade
      />

      {/* === Content Layer (flex positioned on top) === */}
      <div className="absolute inset-0 flex items-end">
        <div className="container mx-auto relative z-10 px-4 pb-20 md:pb-28 pt-32 w-full">
        <div className="max-w-5xl">
          {/* Glassmorphism Background Container (Optional - add subtle glow) */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className="relative"
          >
            {/* Main Headline */}
            <motion.h1
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="font-display text-4xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[6.5rem] uppercase leading-[0.92] mb-6"
            >
              <span className="text-foreground">O Funcional</span>
              <br />
              <span className="text-foreground">Fitness da Paraíba</span>
              <br />
              <span className="text-gradient-neon">começa aqui.</span>
            </motion.h1>

            {/* Subtitle */}
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.7 }}
              className="text-base sm:text-lg text-foreground/80 max-w-xl mb-10 leading-relaxed"
            >
              Regulamentamos, organizamos e promovemos o Funcional Fitness
              no estado da Paraíba. Entidade oficial filiada à CBFF.
            </motion.p>

            {/* CTAs */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.7 }}
              className="flex flex-col sm:flex-row gap-4"
            >
              <Link
                to="/rankings"
                className="inline-flex items-center justify-center px-8 py-4 bg-primary text-primary-foreground font-bold uppercase tracking-[0.12em] text-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_0_30px_hsl(0_100%_42%/0.4)] min-h-[52px]"
              >
                Ver Ranking
              </Link>

              <Link
                to="/filiacao"
                className="inline-flex items-center justify-center px-8 py-4 border border-foreground/20 text-foreground font-bold uppercase tracking-[0.12em] text-sm transition-all duration-300 hover:border-foreground/50 hover:-translate-y-0.5 min-h-[52px] hover:shadow-[0_0_20px_hsl(0_0%_100%/0.1)]"
              >
                Seja Filiado
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </div>
      </div>
    </section>
  );
}
